export default __webpack_public_path__ + "static/media/search_icon_dark_2.40020303.svg";